import { Box, FormControl, Grid, Button } from '@mui/material';
import { maxContactsAllowed } from '../../../settings/appConfig';
import CheckboxInput from './UI/CheckboxInput';
import Panel from '../../../components/UI/Panel';
import useFormatPhone from '../../../hooks/UI/usePhonesHelperMethods';
import GenericInput from './UI/GenericInput';
import useUI from '../../../hooks/context/useUI';
import useValidation from '../../../hooks/validation/useValidation';
import { Add } from '@mui/icons-material';

export default function CustodianContactInfo({
  formik,
  showPanel,
}: Readonly<{
  formik: any;
  showPanel: boolean;
}>) {
  const { formatPhoneNumberOnChange } = useFormatPhone();

  const { isContactsValid } = useValidation();
  const { showSnackbar } = useUI();

  const onAddNewContact = async () => {
    if (isContactsValid(formik.values.contacts) || formik?.values?.contacts?.length === 0) {
      const newItems = [
        ...formik.values.contacts,
        {
          isPrimary: false,
          email: '',
          phoneNumber: '',
          name: '',
          title: ''
        },
      ];
      formik.setFieldValue('contacts', newItems);
    } else {
      showSnackbar(['Please enter a valid contact'], 'error');
    }
  };
  const isPrimaryDisabled = (item: any, index: number, formik: any) => {
  const contacts = formik?.values?.contacts || [];
  const hasPrimary = contacts.some((contact: any) => contact.isPrimary);
  return hasPrimary && !item.isPrimary;
};

  const content = (
    <Grid container spacing={2} mx={1} px={1}>
      {formik?.values?.contacts?.length > 0 &&
        formik?.values?.contacts?.map((item: any, index: number) => (
          <Grid my={2} container key={item.id}>
            <Grid item xs={4} px={2}>
              <GenericInput
                name={`contacts.${index}.name`}
                label="Name"
                maxLength={120}
                placeholder="Name"
                value={item.name}
                onChange={(e: any) => {
                  formik.setFieldValue(
                    `contacts.${index}.name`,
                    e.target.value,
                  );
                }}
                errorMsg={
                  formik?.touched?.contacts?.[index]?.['name'] &&
                    formik?.errors?.contacts?.[index]?.['name']
                    ? formik?.errors?.contacts[index]['name']
                    : ''
                }
                hasError={
                  !!(formik?.touched?.contacts?.[index]?.['name'] &&
                    formik?.errors?.contacts?.[index]?.['name'])
                }
                onBlur={() => {
                  formik.setFieldTouched(`contacts.${index}.name`, true);
                }}
              />
            </Grid>
            <Grid item xs={4} px={2}>
              <GenericInput
                name={`contacts.${index}.phoneNumber`}
                label="Phone"
                maxLength={12}
                placeholder="xxx-xxx-xxxx"
                inputMode="tel"
                value={item.phoneNumber}
                onChange={(e: any) => {
                  formatPhoneNumberOnChange(e);
                  formik.setFieldValue(
                    `contacts.${index}.phoneNumber`,
                    e.target.value,
                  );
                }}
                errorMsg={
                  formik?.touched?.contacts?.[index]?.['phoneNumber'] &&
                    formik?.errors?.contacts?.[index]?.['phoneNumber']
                    ? formik.errors.contacts[index]['phoneNumber']
                    : ''
                }
                hasError={
                  !!(formik?.touched?.contacts?.[index]?.['phoneNumber'] &&
                    formik?.errors?.contacts?.[index]?.['phoneNumber'])
                }
                onBlur={() => {
                  formik.setFieldTouched(`contacts.${index}.phoneNumber`, true);
                }}
              />
            </Grid>
            <Grid item xs={4} px={2}>
              <GenericInput
                name={`contacts.${index}.title`}
                label="Title"
                maxLength={80}
                placeholder="Title"
                value={item.title}
                onChange={(e: any) => {
                  formik.setFieldValue(
                    `contacts.${index}.title`,
                    e.target.value,
                  );
                }}
                errorMsg={
                  formik?.touched?.contacts?.[index]?.['title'] &&
                    formik?.errors?.contacts?.[index]?.['title']
                    ? formik?.errors?.contacts[index]['title']
                    : ''
                }
                hasError={
                  !!(formik?.touched?.contacts?.[index]?.['title'] &&
                    formik?.errors?.contacts?.[index]?.['title'])
                }
                onBlur={() => {
                  formik.setFieldTouched(`contacts.${index}.title`, true);
                }}
              />
            </Grid>
            <Grid item xs={12} my={1}></Grid>
            <Grid item xs={4} px={2}>
              <GenericInput
                name={`contacts.${index}.email`}
                label="Email"
                maxLength={80}
                placeholder="Email"
                value={item.email}
                onChange={(e: any) => {
                  formik.setFieldValue(
                    `contacts.${index}.email`,
                    e.target.value,
                  );
                }}
                errorMsg={
                  formik?.touched?.contacts?.[index]?.['email'] &&
                    formik?.errors?.contacts?.[index]?.['email']
                    ? formik.errors.contacts[index]['email']
                    : ''
                }
                hasError={
                  !!(formik?.touched?.contacts?.[index]?.['email'] &&
                    formik?.errors?.contacts?.[index]?.['email'])
                }
                onBlur={() => {
                  formik.setFieldTouched(`contacts.${index}.email`, true);
                }}
              />
            </Grid>
            <Grid item px={2}>
              <FormControl fullWidth>
                <Box>
                  <CheckboxInput
                    checked={item.isPrimary}
                    disabled={isPrimaryDisabled(
                item,
                index,
                formik
              )}
                    keyName={`contacts[${index}].isPrimary`}
                    label="Primary"
                    onChange={(e: any) => {
                      formik.setFieldValue(
                        `contacts.${index}.isPrimary`,
                        e.target.checked,
                      );
                    }}
                    onBlur={() => {
                      formik.setFieldTouched(
                        `contacts.${index}.isPrimary`,
                        true,
                      );
                    }}
                  />
                </Box>
              </FormControl>
            </Grid>
            <Grid item>
              {formik.values.contacts.length > 1 && (
                <Button
                  type="button"
                  onClick={() => {
                    const newItems = [...formik.values.contacts];
                    newItems.splice(index, 1);
                    formik.setFieldValue('contacts', [...newItems]);
                  }}
                >
                  Remove
                </Button>
              )}
              {index === formik?.values?.contacts?.length - 1 &&
                formik?.values?.contacts?.length < maxContactsAllowed && (
                  <Button
                    type="button"
                    onClick={onAddNewContact}
                    startIcon={<Add />}
                  >
                    Add Other Contact
                  </Button>
                )}
            </Grid>
          </Grid>
        ))}
    </Grid>
  );
  return (
    <>
      {showPanel === true && (
        <Panel headerText="Contact Details">{content}</Panel>
      )}
      {!showPanel && content}
    </>
  );
}

CustodianContactInfo.defaultProps = {
  showPanel: true,
};
